import parsePhoneNumber, { CountryCode } from 'libphonenumber-js';

export const defaultCountry: CountryCode = 'US';

export const formatTelephoneNumber = (telephone: string): string => {
  return parsePhoneNumber(telephone, { defaultCountry })?.formatNational() || telephone;
};

export const formatTelephoneNumberInternational = (telephone: string): string => {
  return parsePhoneNumber(telephone, { defaultCountry })?.formatInternational() || telephone;
};

export const getTelephoneURI = (telephone: string | undefined): string | undefined => {
  return telephone ? parsePhoneNumber(telephone, { defaultCountry })?.getURI() : undefined;
};
